import IMerchantState from "@/types/merchant";
import INotice from "@/types/INotice";

const mutations = {
  SET_MERCHANT_STATE: (
    state: IMerchantState,
    payload: IMerchantState
  ): void => {
    Object.keys(payload).forEach((key) => {
      return (state[key] = payload[key]);
    });
  },

  RESET_MERCHANT_STATE: (state: IMerchantState): void => {
    Object.keys(state).forEach((key) => {
      return (state[key] = null);
    });
  },

  SET_MERCHANT_JWT: (state: IMerchantState, payload: string): void => {
    state.jwt = payload;
  },

  ADD_NOTICE: (state: IMerchantState, payload: INotice): void => {
    const defaults = {
      type: "alert-warning",
      dismissable: false,
    };

    const newNotice = { ...defaults, ...payload };

    const existingNoticeIndex = state.notices.findIndex(
      (notice) => notice.key === newNotice.key
    );
    const noticeExists = existingNoticeIndex >= 0;

    // Prevent duplication of notices by replacing the existing notice...
    if (noticeExists) {
      state.notices.splice(existingNoticeIndex, 1, newNotice);
      return;
    }

    state.notices.push(newNotice);
  },

  SET_GEOLOCATION_ALLOWED: (state: IMerchantState, payload: boolean): void => {
    state.geolocationAllowed = payload;
  },

  SET_GEOLOCATION_CHECK_IN_PROGRESS: (
    state: IMerchantState,
    payload: boolean
  ): void => {
    state.geolocationCheckInProgress = payload;
  },

  SET_GEOLOCATION_CHECK_DONE: (
    state: IMerchantState,
    payload: boolean
  ): void => {
    state.geolocationCheckDone = payload;
  },

  SET_GEOLOCATION_ACTIONS: (
    state: IMerchantState,
    payload: { [key: string]: boolean }
  ): void => {
    state.geolocationActions = payload;
  },
};

export default mutations;
